(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncMotion = () => {
    document.querySelectorAll('[data-nov-pdp] video[autoplay]').forEach((video) => {
      if (reducedMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMotion, { once: true });
  } else {
    syncMotion();
  }

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', syncMotion);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(syncMotion);
  }
})();
